module.exports = __webpack_public_path__ + "static/pavlo_zubrytskyi-108d3c8bed3f5ea093e102dc103298e1.png";